import type { Shape } from '~/types/grid.types'

export const PEAK_FREEFORM_SHAPES: Shape[] = [
  {
    type: 'rect',
    id: 'SmallPeakFreeform',
    icon: 'SmallPeak',
    prefix: 'SmallPeak',
    label: 'Small Peak',
    w: 60,
    h: 120,
    menuAlign: 'right',
    children: [
      {
        type: 'rect',
        id: 'SmallPeakFreeform90',
        icon: 'SmallPeak',
        prefix: 'SmallPeak',
        label: 'Small Peak 90°',
        w: 60,
        h: 120,
        rotation: 90,
      },
    ],
  },
  {
    type: 'rect',
    id: 'LargeCenterPeakFreeform',
    icon: 'LargeCenterPeak',
    prefix: 'LargeCenterPeak',
    label: 'Large Center Peak',
    w: 60,
    h: 240,
    menuAlign: 'right',
    children: [
      {
        type: 'rect',
        id: 'LargeCenterPeakFreeform90',
        icon: 'LargeCenterPeak',
        prefix: 'LargeCenterPeak',
        label: 'Large Center Peak 90°',
        w: 60,
        h: 240,
        rotation: 90,
      },
    ],
  },
  {
    type: 'rect',
    id: 'LargeUpperPeakFreeform',
    icon: 'LargeUpperPeak',
    prefix: 'LargeUpperPeak',
    label: 'Large Upper Peak',
    w: 60,
    h: 240,
    menuAlign: 'right',
    children: [
      {
        type: 'rect',
        id: 'LargeUpperPeakFreeform90',
        icon: 'LargeUpperPeak',
        prefix: 'LargeUpperPeak',
        label: 'Large Upper Peak 90°',
        w: 60,
        h: 240,
        rotation: 90,
      },
      {
        type: 'rect',
        id: 'LargeUpperPeakFreeform180',
        icon: 'LargeUpperPeak',
        prefix: 'LargeUpperPeak',
        label: 'Large Upper Peak 180°',
        w: 60,
        h: 240,
        rotation: 180,
      },
      {
        type: 'rect',
        id: 'LargeUpperPeakFreeform270',
        icon: 'LargeUpperPeak',
        prefix: 'LargeUpperPeak',
        label: 'Large Upper Peak 270°',
        w: 60,
        h: 240,
        rotation: 270,
      },
    ],
  },
]
